export default function ShadowDefs({id = "shadow"}) {
    return (
        <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
            <feDropShadow
                dx="0"
                dy="0"
                stdDeviation="2"
                floodColor="#333"
                floodOpacity="0.6"
            />
        </filter>
    );
}